/* eslint-disable react-hooks/exhaustive-deps */
import '../assets/css/details.css';

// import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

//import logo from '../assets/dai-logo-125.png';
import { Howmany } from '../components/Howmany';
import { NftContext } from '../providers/NftProvider';
import { networkList } from '../config/networks';
import { HARDHAT_NETWORK_ID } from '../providers/AuthProvider';

const Details = () => {
  const history = useHistory();
  const nftInfos = useContext(NftContext);
  const [howMany, setHowMany] = useState(false);
  const queryParam = new URLSearchParams(history.location.search).get('artwork');
  const [nft, setNft] = useState(nftInfos.nfts.find((nft) => nft.address === queryParam));
  const networkData = networkList.networks[0][parseInt(HARDHAT_NETWORK_ID,10)];

  //Retrieve nft with queryParam
  useEffect(() => {
    setNft(nftInfos.nfts.find((nft) => nft.address === queryParam));
  }, [nftInfos.nfts.length]);
  const bigPicUrl = nft ? nft.artUrl : null;
  const picType = nft.picType.split('/')[0];
  console.log("picType: ", picType)

  const convertUrl = (oldUrl) => {
    //ipfs://bafkreibdns44udgjkqciytd6f67uh5c3spxrmptoi2ezmwstehcgg2rm6i
    //https://bafkreif5oqptjnxxu4bhgauqv7e7ytohptwfs3vnr67x5vmmoykm4xevy4.ipfs.dweb.link
    
    console.log("convertUrl ori: ", oldUrl);
    if (oldUrl.match("https://")) {
      //console.log("convertUrl: ", oldUrl);
      return oldUrl
    }
    const hashUrl = oldUrl.split('/')[2];
    //const newUrl = 'https://' + hashUrl + '.ipfs.dweb.link';
    const newUrl = 'https://ipfs.io/ipfs/' + hashUrl;
    //console.log("convertUrl: ", newUrl);
    return newUrl;
  }

  // Handle image ratio
  const artImg = useRef(null);
  const [horizontalImg, setHorizontalImg] = useState(false);
  const [verticalImg, setVerticalImg] = useState(false);

  useEffect(() => {
    let ratio = 1;
    if(picType !== 'video') {
      ratio = artImg.current?.naturalHeight / artImg.current?.naturalWidth;
      ratio < 0.5 ? setHorizontalImg(true) : setHorizontalImg(false);
      ratio > 1 ? setVerticalImg(true) : setVerticalImg(false);
    }
    console.log("ratio: ", ratio);
  }, [artImg]);

  // Handle mint amount
  const FromHowMany = async (quantity) => {
    setHowMany(quantity);
    try {
      //await nftInfos.approveAndBuy(nft.address, quantity, nft.price);
      await nftInfos.mintNft(nft.address, quantity);
    } catch (e) {
      console.error('Error while minting', e);
    }
  };

  // Open Pdf in new tab
  const handlePdfClick = () => {
    /* window.open(nft.pdfUrl, '_blank'); */
    window.open(convertUrl(nft.pdfUrl), '_blank');
  };

  if (!nft) {
    return (
      <div className="container full">
        <div className="spinner-border spinner" role="status"></div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="col justify-content-center cardsDetail">
        <div className="card bg-primary border-light shadow-inset border-light cardLarge">
          <div className="row">
            <div
              className={`card-header p-3 ${
                picType === 'video' ? 'col-xl-12 col-lg-12 col-md-12 ' : horizontalImg ? 'col-xl-12 col-lg-12 col-md-12 ' : verticalImg ? 'col-xl-5 col-lg-5 col-md-12' : 'col-xl-8 col-lg-8 col-md-12'
              }`}
            >
              <div className="pt-1 ml-3 mr-3">
                { picType === 'video' ? (
                  <video controls className="detailVideo">
                    <source src={bigPicUrl} type={nft.picType}></source>
                  </video>
                ) : (
                  <img src={bigPicUrl} className="card-img-top picLarge" alt={nft.name} ref={artImg} />
                )}
              </div>
            </div>
            <div
              className={`card-body d-flex flex-column pt-0 ${
                picType === 'video' ? 'col-xl-12 col-lg-12 col-md-12 ' : horizontalImg ? 'col-xl-12 col-lg-12 col-md-12' : verticalImg ? 'col-xl-7 col-lg-7 col-md-12' : 'col-xl-4 col-lg-4 col-md-12'
              }`}
            >
              <div className="d-flex align-items-center justify-content-center pt-3">
                {/*<span className="nft-infos mr-2"><b>{nft.name}</b></span>-<span className="nft-infos ml-2"><b>{nft.author}</b></span>*/}
                {/*<span className="mr-2 img-fluid"><i>{nft.name}</i> created by {nft.author}</span>*/}
                <span className="mr-2"><b><i>{nft.name}</i></b></span><span>by</span><span className="ml-2">{nft.author}</span>
              </div>
              <div className="pt-0 d-flex justify-content-center">
                <div className="d-flex pt-3 ml-2 justify-content-center">
                { nft.left > 0 ? (<span className="nft-infos ml-2">You can mint {nft.left} of these.</span>) : (<span className="nft-infos ml-2">&nbsp;</span>)}
                </div>
                
              </div>
              <div className="d-flex mt-auto align-items-center justify-content-center">
                <h3 className="h5 card-title mt-0 text-center infosCard" style={{'whiteSpace': 'pre-line'}}>{nft.description}</h3>
              </div>
              <div className="d-flex mt-auto align-items-end justify-content-center">
                { nft.left > 0 ? (
                <button className="btn btn-primary btn-pill mt-4 ml-2" onClick={() => setHowMany(true)}>
                    <span className="mr-2 img-fluid">Mint</span>
                </button>
                ) : (
                  <span></span>
                  )}
  
                <button className="btn btn-primary btn-pill mt-4 ml-2" onClick={() => handlePdfClick()}>
                  <span className="mr-2 img-fluid">IP License</span>
                </button>
                {howMany && <Howmany FromHowMany={FromHowMany} ToMax={nft.max} />}
              </div>

              <div className="d-flex justify-content-center mt-2">
                    <span className="mr-2 img-fluid"><a href={networkData.opensea} target="_blank" rel="noreferrer">Sell on OpenSea</a></span>
              </div>
              <div className="d-flex justify-content-end mr-2 etherLink mt-2">
                <span><a href={`${networkData.scanlink}address/${nft.address}`} target="_blank" rel="noreferrer">Blockchain Explorer</a> | <a href={nft.metadatasUrl} target="_blank" rel="noreferrer">NFT Metadata</a></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
